import React from 'react';
import { Link, useParams } from 'react-router-dom';
import moment from 'moment';
import {
    Ticket,
    TicketHeader,
    TicketBody,
    HorizontalFlex,
    VerticalFlex,
    AccentLabel,
    PadContainer,
} from 'smartsuite-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

export default function BagSearchResults(props) {
    const { bagTag } = useParams();
    const { t } = useTranslation('bagSummary');

    const date = moment(props.bagSelectorResult.createdOn);
    const dayOfMonth = date.format('DD');
    const month = date.format('MMM').toUpperCase();

    const passengerName = props.bagSelectorResult.passengerName || '-';
    const pnr = props.bagSelectorResult.pnr || '-';

    const className = props.isSelected
        ? 'bag-search__results-ticket bag-search__results-ticket--selected'
        : 'bag-search__results-ticket';

    const stations = props.flightItinerary
        .map((itinerary) => itinerary.stationName)
        .sort((a, b) => a.order - b.order);

    const formattedItinerary = stations.join('-');

    return (
        <div className={className}>
            <Ticket cssClassModifiers={['always-column']}>
                <TicketHeader size={'is-full'}>
                    <PadContainer cssClassModifiers={['pad-small']}>
                        <HorizontalFlex cssClassModifiers={['space-between']}>
                            <VerticalFlex>
                                <AccentLabel>{t('bagTagCreated')}</AccentLabel>
                                <span className="passengerName">
                                    {dayOfMonth}
                                    {month}
                                </span>
                            </VerticalFlex>
                            <HorizontalFlex cssClassModifiers={['center']}>
                                <Link
                                    className="bag-search__results-ticket--select"
                                    to={`/BagSummary/${bagTag}/${props.bagSelectorResult.id}`}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        props.onBagSelect(
                                            props.bagSelectorResult.id
                                        );
                                        window.scrollTo({
                                            top: 0,
                                            behavior: 'smooth',
                                        });
                                    }}
                                >
                                    Select
                                    <span className="far fa-arrow-alt-circle-right"></span>
                                </Link>
                            </HorizontalFlex>
                        </HorizontalFlex>
                    </PadContainer>
                </TicketHeader>
                <TicketBody>
                    <div className="bag-search__results-ticket-body">
                        <VerticalFlex>
                            <AccentLabel>{t('passenger')}</AccentLabel>
                            <div className="bag-search__results-ticket-body-passenger-name">
                                {passengerName}
                            </div>
                        </VerticalFlex>
                        <VerticalFlex>
                            <AccentLabel>{t('pnr')}</AccentLabel>
                            <div>{pnr}</div>
                        </VerticalFlex>
                        <VerticalFlex>
                            <AccentLabel>{t('itinerary')}</AccentLabel>
                            <div>{formattedItinerary}</div>
                        </VerticalFlex>
                    </div>
                </TicketBody>
            </Ticket>
        </div>
    );
}

BagSearchResults.propTypes = {
    bagSelectorResult: PropTypes.instanceOf(Object),
    flightItinerary: PropTypes.instanceOf(Array),
    isSelected: PropTypes.bool.isRequired,
    onBagSelect: PropTypes.func.isRequired,
};
